export default {
  nav: {
    home: 'Startseite',
    video: 'Videoüberwachung',
    alarm: 'Alarmanlagen',
    solutions: 'Lösungen',
    care: 'SSG Care',
    planner: 'KameraPlaner',
    areas: 'Servicegebiete',
    about: 'Über uns',
    contact: 'Kontakt',
  },
  dropdown: {
    allSolutions: 'Alle Lösungen ansehen',
    homeGrounds: 'Zuhause & Grundstück',
    retailGastro: 'Einzelhandel & Gastronomie',
    officePractice: 'Büro & Praxis',
    warehouseLogistics: 'Lager & Logistik',
    workshopTrade: 'Werkstatt & Gewerbe',
    apartments: 'Mehrfamilienhäuser & Immobilien',
    cameraTypes: 'Kameratypen',
    services: 'Leistungen',
    technology: 'Technik',
  },
  footer: {
    brandLine: 'Sicherheitstechnik für Privat & Gewerbe',
    area: 'Hainburg · Rhein-Main-Gebiet',
    services: 'Leistungen',
    solutions: 'Lösungen',
    forWhom: 'Für wen',
    contact: 'Kontakt',
    areaLabel: 'Einsatzgebiet Rhein-Main',
    privateCustomers: 'Privatkunden',
    businessCustomers: 'Gewerbekunden',
    allSolutions: 'Alle Lösungen',
    faq: 'FAQ',
    rights: 'Alle Rechte vorbehalten.',
    impressum: 'Impressum',
    privacy: 'Datenschutz',
    cookieSettings: 'Cookie-Einstellungen',
  },
  related: {
    eyebrow: 'Weitere Lösungen',
    title: 'Andere Objekttypen entdecken',
    viewAll: 'Alle Lösungen ansehen',
  },
};